import { defineMessages } from 'react-intl';

export default defineMessages({
    WatercraftTypeLabel: {
        id: 'common.views.ml-pup-add-watercraft.Watercraft Type',
        defaultMessage: 'Watercraft Type'
    },
    WatercraftPopupTooltipLabel: {
        id: 'common.directives.templates.ml-pup-add-watercraft-dialog.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    YearLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Year',
        defaultMessage: 'Year'
    },
    MakeLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Make',
        defaultMessage: 'Make'
    },
    ModelLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Model',
        defaultMessage: 'Model'
    },
    HINLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.HIN',
        defaultMessage: 'HIN'
    },
    MyPolicyLabel: {
        id: 'common.views.ml-pup-add-watercraft.My Policy Info',
        defaultMessage: 'My Policy Info'
    },
    LengthLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Length in Feet',
        defaultMessage: 'Length in Feet'
    },
    HorsePowerLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Horsepower',
        defaultMessage: 'Horsepower'
    },
    MaxMPHLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.Max Speed in MPH',
        defaultMessage: 'Max Speed in MPH'
    },
    MoorStateLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.State Moored',
        defaultMessage: 'State Moored/Located'
    },
    WatercraftTypeTooltipLabel: {
        id: 'quoteandbind.pup.directives.templates.ml-pup-watercraft-dialog.watercraftType help title',
        defaultMessage: 'Which watercraft type should I select?'
    },
    WatercraftTypeTooltipContent: {
        id: 'quoteandbind.pup.directives.templates.ml-pup-watercraft-dialog.watercraftType help message',
        defaultMessage: `<p>Bass boat – a small boat designed and equipped primary for bass fishing typically in freshwater lakes, rivers and streams.</p><br/>
        <p>Personal Watercraft – also called a water scooter or jetski is a recreational watercraft that the rider sits or stand on, rather than sits inside of.</p><br/>
        <p>Pontoon – is a flat bottom boat that relies on pontoons to float. </p><br/>
        <p>Sailboat with Auxiliary – is a wind-powered boat using sails for propulsion but also has an auxiliary engine that can be used in adverse weather conditions or for maneuvering in confined spaces.</p><br/>
        <p>Sailboat without Auxiliary – is a wind-powered boat using sails for propulsion. The boat does not contain an auxiliary engine for power.</p><br/>
        <p>Speed boat – is a motorboat with a powerful engine designed for high speed.</p>`
    },
    WatercraftTypeTooltipContentNP: {
        id: 'quoteandbind.pup.directives.templates.ml-pup-watercraft-dialog.watercraftType NP help message',
        defaultMessage: `<p>Bass boat – a small boat designed and equipped primary for bass fishing typically in freshwater lakes, rivers and streams.</p><br/>
        <p>Personal Watercraft – also called a water scooter or jetski is a recreational watercraft that the rider sits or stand on, rather than sits inside of.</p><br/>
        <p>Pontoon – is a flat bottom boat that relies on pontoons to float. </p><br/>
        <p>Sailboat with Auxiliary – is a wind-powered boat using sails for propulsion but also has an auxiliary engine that can be used in adverse weather conditions or for maneuvering in confined spaces.</p><br/>
        <p>Sailboat without Auxiliary – is a wind-powered boat using sails for propulsion. The boat does not contain an auxiliary engine for power.</p><br/>
        <p>Speed boat – is a motorboat with a powerful engine designed for high speed.</p>
        <p>Sport Fisher - is a specialized powerboat, designed for recreation, high-speed, and big-game angling typically featuring an open cockpit.</p>
        <p>Trawler - is a larger boat used for fishing or slow-speed recreation cruising.</p>`
    },
    HINTooltipLabel: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.HIN help title',
        defaultMessage: 'Where do I find my HIN?'
    },
    HINTooltipContent: {
        id: 'ml.edge.common.directives.templates.ml-pup-add-watercraft-content.HIN help message',
        defaultMessage: 'The HIN (hull identification number) is a 12 character serial number that uniquely identifies your boat. An HIN is on all boats built after November 1972. It is typically affixed to the rear of the transom usually on the upper right corner. If the vessel does not have a transom, it will be located on the starboard side of the aft end of the hull. The HIN is not the same as a state registration number which may be required by your state to be displayed on the bow of your boat.'
    },
    ExcludeWatercraftTooltipContent: {
        id: 'common.directive.templates.ml-pup-watercraft-content.You have chosen to exclude this watercraft from coverage under your Umbrella policy.',
        defaultMessage: 'You have chosen to exclude this watercraft from coverage under your Umbrella policy.'
    },
    ExcludeWatercraftRadioTitle: {
        id: 'common.directives.templates.ml-pup-add-watercraft-dialog.Would you like to exclude this watercraft?',
        defaultMessage: 'Would you like to exclude this watercraft?'
    },
    GPAButtonLabel: {
        id: 'common.directives.templates.ml-pup-add-watercraft-dialog.Add Watercraft Operator',
        defaultMessage: 'Add Watercraft Operator'
    },
    Continue: {
        id: 'common.directives.templates.ml-pup-add-watercraft-dialog.Continue',
        defaultMessage: 'Continue'
    }
});
